'use client';

import {useContext} from 'react';
import styled from '@emotion/styled';

import theme from 'theme';

import {SidebarMenuContext} from 'SidebarMenu/SidebarMenu';

import {MenuItemBadge} from '../MenuItemBadge';

import {Left} from './Left';

import type {SidebarMenuItemStyles, SidebarMenuItemProps} from 'SidebarMenu/types';
import type {ElementType} from 'react';

const ChildContainer = styled.div<SidebarMenuItemStyles>`
  position: relative;
  display: block;
  padding: 4px;
  text-decoration: none;

  cursor: ${props => (props.disabled ? 'default' : 'pointer')};

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 8px 8px 34px;
    border-radius: 4px;
  }

  :hover > div {
    background-color: ${props => (!props.isSelected ? theme.colors.grey[20] : undefined)};
  }
`;

export const MenuItemChild: React.FC<SidebarMenuItemProps> = props => {
  const {isSelected, onClick} = useContext(SidebarMenuContext);

  const {label, icon, badge, disabled, qa, href, target} = props;

  const styles = {disabled, isSelected: isSelected(props)};

  const anchorProps = href ? {href, target, as: 'a' as ElementType} : undefined;

  const containerProps = {
    ...styles,
    ...anchorProps,

    onClick: onClick(props),

    'data-qa': qa,
  };

  const leftProps = {...styles, label, icon};
  const badgeProps = {...styles, badge};

  return (
    <div>
      <ChildContainer {...containerProps}>
        <div>
          <Left {...leftProps} />
          <MenuItemBadge {...badgeProps} />
        </div>
      </ChildContainer>
    </div>
  );
};
